import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Componente de modal genérico
 *
 * Uso:
 * <app-generic-modal
 *   [title]="'Título do Modal'"
 *   [isOpen]="modalOpen"
 *   [showCloseButton]="true"
 *   [showBackdrop]="true"
 *   (closeModal)="handleClose()"
 * >
 *   Conteúdo do modal aqui
 * </app-generic-modal>
 */
@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss']
})
export class GenericModalComponent {
  @Input() isOpen: boolean = false;
  @Input() showBackdrop: boolean = true;
  @Output() closeModal = new EventEmitter<void>();

  isClosing = false;

  onClose(): void {
    this.isClosing = true;
  }

  onBackdropClick(): void {
    if (this.showBackdrop) {
      this.onClose();
    }
  }

  onAnimationEnd(): void {
    if (this.isClosing) {
      this.isClosing = false;
      this.closeModal.emit();
    }
  }
}
